      <div class="col-md-10">
      <h3>Reset Your Password</h3>
      <form *ngIf="!success" (ngSubmit)="forgotyourpassword()" #registerForm="ngForm" autocomplete="off" >
            <div *ngIf="failure" class="alert alert-danger" i18n="@@errFailureEmailNotReg">The email specified is not registered as an individual. <a [routerLink]="['/ind-register']" class="btn btn-link">Click here to register</a>  Or <a (click)="reloadPage()" class="btn btn-link">Click here to reset password for a different email.</a></div>
            <div class="form-group">
                  <label for="email" i18n="@@lblEmail"> Email : </label>
                  <input type="text" class="form-control" id="email" name="email" autocomplete="off" [(ngModel)]="model.email" 
                  #email="ngModel" required pattern="[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,4}$">
                  <div [hidden]="email.valid || email.pristine" class="alert alert-danger" i18n="@@valRegEmailReqd">
                        Please enter the email id registered with Onreference.
                  </div>
            </div>
            <re-captcha
                  [(ngModel)]="formModel.captcha"
                  name="captcha"
                  required
                  siteKey="6LfQfCkUAAAAAJgZfY8xY3JdG71PSrxNazVm-2Ol"
                  #captchaControl="ngModel"
            ></re-captcha>
            
            <div class="form-group">                  
                  <!--<button type="submit" class="btn btn-primary" [disabled]="!registerForm.valid || loading || failure " i18n="@@btnSubmit">Submit</button>-->
                  <button type="submit" class="btn btn-primary" [disabled]="!registerForm.valid || loading || failure " ><span i18n="@@btnSubmit"> Submit </span> <i *ngIf="loading" class="fa fa-spinner fa-pulse"></i></button>
                  <a *ngIf="!loading" [routerLink]="['/ind-login']" class="btn btn-link" i18n="@@btnCancel">Cancel</a>            
            </div>
      </form>
      <div *ngIf="success" i18n="@@msgCheckEmailPwdReset">Please check your email for the password reset link. If you did not receive the email, check if the email was saved in your email spam. Thanks.</div>
      <div *ngIf="success"><a [routerLink]="['/ind-login']" class="btn btn-link" i18n="@@msgGoToLogin">Go to Sign In page</a></div>

      </div>